import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';

import { loadUser } from '~src/services/api/user';
import { DbUser } from '~src/types/db';
import { useProjectId } from '../useProjectId';

interface UseUserParams {
  user_id?: number | null;
  project_id?: number | null;
}

export const useUser = (
  { user_id, project_id }: UseUserParams = {},
  queryConfig: QueryConfig<DbUser | undefined, AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const projectId = useProjectId();

  const { enabled, ...options } = queryConfig;

  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const resolvedProjectId = project_id ?? projectId;

  const userQuery = useQuery<DbUser | undefined, AxiosError>(
    [
      'user',
      {
        projectId: String(resolvedProjectId || ''),
        user_id,
      },
    ],
    loadUser,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,

      // Only request a user when we actually have a valid user_id
      enabled: !!enabledOverwrite && !!resolvedProjectId && !!user_id,

      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return userQuery;
};
